<template>
	<v-layout row wrap>

		<v-flex class="mb-4" xs12 >
			<h1 class="title mb-2">My Thirteen Month</h1>
			<div style="min-height:400px;">
				<v-card class="mb-3 mr-3" >
					<v-toolbar card class="blue dark-3">
						<span class="title white--text">List of Thirteen Month</span>
					</v-toolbar>
					<v-list class="ma-0 pa-0">
						<template v-for="(thirteen_month,i) in thirteen_months">
							<v-list-tile :class=" (i%2)? 'grey lighten-4' : 'grey lighten-3' ">	
								<v-list-tile-avatar>
					              <v-icon color="light-blue darken-3">fas fa-file-alt</v-icon>
					            </v-list-tile-avatar>
								<v-list-tile-content>
									<v-list-tile-title><span class="font-weight-medium">December</span> &nbsp; <span class="font-weight-medium">{{ thirteen_month.year }}</span></v-list-tile-title>
								</v-list-tile-content>
								<v-list-tile-action>
					              <v-btn
					              	depressed
									color="light-blue lighten-1"
									class="white--text"
									@click="thirteenMonthsDetailsFunc(thirteen_month)"
									target="_blank"
									>View
										<v-icon right small dark>fas fa-search</v-icon>
									</v-btn>
					            </v-list-tile-action>
							</v-list-tile>
						</template>
						<v-layout row wrap class="text-xs-center">
							<v-flex md12>
								<v-pagination
								v-model="pagination.page"
								:length="pagination.length"
								:disabled="isLoading"
								total-visible="10" 
								circle>
									
								</v-pagination>
							</v-flex>
						</v-layout>
					</v-list>
				</v-card>
			</div>
		</v-flex>

		<v-dialog
        v-model="thirteenMonthsDetailsDialog"

        hide-overlay
        transition="dialog-bottom-transition"
        scrollable
      	>
        <v-card tile>
	      <v-toolbar
            flat
            dark
            color="primary"
	        >
            <v-btn
              icon
              dark
              @click="thirteenMonthsDetailsDialog = false"
            >
              <v-icon>fas fa-times-circle</v-icon>
            </v-btn>
            <v-toolbar-title>Details</v-toolbar-title>
             <v-spacer></v-spacer>

	     	 
          </v-toolbar>	

          <v-card-text>
          	<div class="elevation-1">
	          	<div class="v-table__overflow">
							  <table
							    class="v-datatable v-table theme--light"
							  >
							      <tr>
								      <th class="text-start ">Employee ID</th><td class="text-md-center">{{thirteenMonthsDetails.employee_id}}</td>
								      <th class="text-start ">Employee Name</th><td class="text-md-center">{{thirteenMonthsDetails.employee_name}}</td>
							      </tr>
							      <tr>
								      <th class="text-start ">For Year </th>
								      <td class="text-md-center">{{thirteenMonthsDetails.year}}</td>
								      <th class="text-start ">Department</th><td class="text-md-center">{{thirteenMonthsDetails.department}}</td>
							      </tr>
							      <tr>
								      <th class="text-start ">Annual Salaries</th><td class="text-md-center">{{thirteenMonthsDetails.annual_salaries}}</td>
								      <th class="text-start ">Tardy </th><td class="text-md-center">{{thirteenMonthsDetails.tardy}}</td>
							      </tr>
							      <tr>
							      	<th class="text-start ">Net Gross</th><td class="text-md-center">{{thirteenMonthsDetails.net_gross}}</td>
								      <th class="text-start ">Thirteen Month </th>
								      <td class="text-md-center">
								      	{{thirteenMonthsDetails.thirteen_month}}
								  	  </td>
								      
							      </tr>
							      <tr>
							      	<th class="text-start ">Deduction</th><td class="text-md-center">{{thirteenMonthsDetails.deduction}}</td>
								      <th class="text-start ">Net Amount</th><td class="text-md-center">{{thirteenMonthsDetails.net_amount}}</td>
								      
							      </tr>
							  </table>
							 </div>
						</div>

          </v-card-text>

          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>

      <v-dialog
	      v-model="dialogDownload"
     	  max-width="290"
	    >
	      <v-card>
	      	<v-card-title>
		      <center><span class="title font-weight-medium">Message</span></center>
	        </v-card-title>

	        <v-card-text>
	          Start downloading, please wait...
	        </v-card-text>
	        <v-divider></v-divider>
	        <v-card-actions>
	          <v-btn
	            depressed
	            text
	            @click="dialogDownload = false"
	          >
	            Close
	          </v-btn>
	        </v-card-actions>
	      </v-card>
	    </v-dialog>

	</v-layout>
</template>
<style scoped>
	.payslip-detail-top {
		padding: 20px;
	}
	table tr th, table  tr td:not(:last-child) {
	    border-right: 1px solid rgb(221, 221, 221);
	}
	table.v-table  td, table.v-table  th {
	    height: 48px;
	}	
	table  tr th, table  tr td, table tr td:not(:last-child){
	    border: 1px solid #bbb !important;
	}
	.bb0 {
		border-bottom: 0px;
	}
</style>
<script>
	import VueCookies from 'vue-cookies';
	import axios from 'axios';

	export default {
		created : function(){
			this.token = (VueCookies.get(this.cookieKey)).token;
			let _this = this;
			_this.token = (VueCookies.get(_this.cookieKey)).token;
			_this.id = (VueCookies.get(_this.cookieKey)).data.user.id;
			_this.eventHub.$emit("openGlobalLoaderModal");
			_this.getUsers()
			.then(function(res){
				_this.employee.fname = res.data.data.firstname;
				_this.employee.lname = res.data.data.lastname;
				_this.employee.employee_id = res.data.data.employee_id;
				_this.employee.id = res.data.data.id;

				_this.getAndListThirteenMonths();

				_this.eventHub.$emit("closeGlobalLoaderModal");
			});
		},

		data : function() {
			return {
				token : '',
				id : 0,
				thirteen_months : [],
				employee : {
					fname : '',
					lname : '',
					employee_id : '',
					id : ''
				},
				pagination : {
					length : 0,
					page : 1
				},
				isLoading : false,
				thirteenMonthsDetailsDialog : false,
				thirteenMonthsDetails : [],
				dialogDownload: false
			}
		},

		mounted : function(){
			
		},

		watch : {
			"pagination.page" : function(){
				this.getAndListThirteenMonths();
			}
		},
		
		methods : {
			thirteenMonthsDetailsFunc : function(item){
				console.log(item);
				this.thirteenMonthsDetails = item;
				this.thirteenMonthsDetailsDialog = true;
			},		
			formatMoney : function(number, decPlaces, decSep, thouSep) {
				decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
				decSep = typeof decSep === "undefined" ? "." : decSep;
				thouSep = typeof thouSep === "undefined" ? "," : thouSep;
				var sign = number < 0 ? "-" : "";
				var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
				var j = (j = i.length) > 3 ? j % 3 : 0;

				return sign +
					(j ? i.substr(0, j) + thouSep : "") +
					i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
					(decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
			},	
			getAndListThirteenMonths : function(){
				this.eventHub.$emit("openGlobalLoaderModal");
				this.getThirteenMonths()
				.then((response) => {
					this.listThirteenMonth(response.data.data);
					console.log(response);
					this.eventHub.$emit("closeGlobalLoaderModal");
				});

			},

			getThirteenMonths : function(){
				let _this = this;
				return axios.create({
					baseURL : this.apiUrl,
					headers : {
						'Authorization' : `Bearer ${_this.token}`
					}
				})
				.get('/payslip/thirteen_month/list', {
					'params' : {
						'id' : _this.employee.id,
						'page' : _this.pagination.page
					}
				});
			},

			getUsers : function(){
				let _this = this;
				return axios.create({
					baseURL : _this.apiUrl,
					headers : {
						'Authorization' : `Bearer ${_this.token}`
					}
				})
				.get('/users/profile', {
					'params' : {
						'id' : _this.id
					}
				});
			},
			listThirteenMonth : function(data){
				console.log('data', data);
				this.thirteen_months = data.thirteen_months;
				this.pagination.length = data.pagination.pages
			}

		},

	};
</script>